import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {CityDTO} from '../../../shared/dto/city.model';
import {InventoryModel} from '../../../shared/dto/inventory.model';
import {HistoryModel} from '../../../shared/dto/history.model';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {ApplicantRequestService} from '../../../service/applicant-request.service';
import swal from "sweetalert2";

@Component({
  selector: 'app-inventory-search-table',
  templateUrl: './inventory-search-table.component.html',
  styleUrls: ['./inventory-search-table.component.scss']
})
export class InventorySearchTableComponent implements OnInit {
  public historyModel: InventoryModel[];

  displayedColumns: string[] = ['serial', 'sid','status', 'date','user','action'];
  dataSource: MatTableDataSource<any>;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  constructor(private applicantRequestService: ApplicantRequestService) { }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.applicantRequestService.searchInventory().subscribe(
      (result: any ) => {
        this.historyModel = result;
        this.dataSource = new MatTableDataSource(this.historyModel);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  deleteRow(id) {
    swal.fire({
      title: "Are you sure, you want to delete?",
      text: "",
      showCancelButton: true,

      confirmButtonText: "Yes"
    }).then((result)=> {
        if(result.value) {
          this.applicantRequestService.deleteInventory(id,"").subscribe(
            (success: string) => {
              this.loadData();
              swal.fire("Success", "Details deleted successfully", "success");
            },
            (error) => {
              console.log(error);
              this.loadData();
              swal.fire("Success", "Details deleted successfully", "success");
            },
          );
        }
      }, reason => {
      }
    );
  }

}
